import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountingInvoicesXEmployeeGroupedReport } from "src/models/Accounting/AccountingReports.models";

interface AccountingInvoicesXEmployeeGroupedReportState {
  invoicesXEmployeeGroupedReports: IAccountingInvoicesXEmployeeGroupedReport[];
}

const initialState: AccountingInvoicesXEmployeeGroupedReportState = {
  invoicesXEmployeeGroupedReports: [],
};

const AccountingInvoicesXEmployeeGroupedReportSlice = createSlice({
  name: "AccountingInvoicesXEmployeeGroupedReport",
  initialState,
  reducers: {
    setAccountingInvoicesXEmployeeGroupedReportList: (
      state,
      action: PayloadAction<IAccountingInvoicesXEmployeeGroupedReport[]>
    ) => {
      state.invoicesXEmployeeGroupedReports = action.payload;
    },
    concatListAccountingInvoicesXEmployeeGroupedReport: (
      state: AccountingInvoicesXEmployeeGroupedReportState,
      action: PayloadAction<IAccountingInvoicesXEmployeeGroupedReport[]>
    ) => {
      state.invoicesXEmployeeGroupedReports = [
        ...state.invoicesXEmployeeGroupedReports.concat(action.payload),
      ];
    },
  },
});

export const {
  setAccountingInvoicesXEmployeeGroupedReportList,
  concatListAccountingInvoicesXEmployeeGroupedReport,
} = AccountingInvoicesXEmployeeGroupedReportSlice.actions;

export default AccountingInvoicesXEmployeeGroupedReportSlice.reducer;
